import * as React from 'react';
const Hash = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: props.size || '1em', height: props.size || '1em', viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", className: "feather feather-hash", ...props },
    React.createElement("line", { x1: "4", y1: "9", x2: "20", y2: "9" }),
    React.createElement("line", { x1: "4", y1: "15", x2: "20", y2: "15" }),
    React.createElement("line", { x1: "10", y1: "3", x2: "8", y2: "21" }),
    React.createElement("line", { x1: "16", y1: "3", x2: "14", y2: "21" })));
export default Hash;
//# sourceMappingURL=Hash.js.map